export const usePhotoManager = () => {
    return null;
};
